import styled from '@benzinga/themetron';

export const EmptyChart = styled.div({
  alignItems: 'center',
  display: 'flex',
  height: '200px',
  justifyContent: 'center',
});
